'use client';
import { useEffect, useState } from 'react';
import { showLoading, showSuccess, showError } from '@/lib/toast';
import { useGatewayEvents } from '@/lib/useGatewayEvents';

export default function QueuePage() {
  const [taskJobs, setTaskJobs] = useState<any[]>([]);
  const [agentJobs, setAgentJobs] = useState<any[]>([]);
  const [plans, setPlans] = useState<any[]>([]);

  async function load() {
    const res = await fetch('/api/queue');
    const data = await res.json();
    setTaskJobs(data.tasks || []);
    setAgentJobs(data.agentJobs || []);
    setPlans(data.plans || []);
  }

  useEffect(() => {
    load();
  }, []);

  useGatewayEvents(
    ['task.created', 'task.started', 'task.completed', 'task.failed'],
    () => {
      void load();
    },
  );

  async function doAction(id: string, action: string, queueName?: string) {
    const actionText = action === 'retry' ? 'Thử lại' : action === 'remove' ? 'Xóa' : action;
    const toastId = showLoading(`${actionText} job...`);
    
    try {
      const res = await fetch('/api/queue', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, id, queueName }),
      });
      
      if (!res.ok) {
        throw new Error('Không thể thực hiện thao tác');
      }
      
      await load();
      showSuccess(`${actionText} job thành công!`, toastId);
    } catch (error) {
      showError(`Lỗi khi ${actionText.toLowerCase()} job`, toastId);
      console.error('Queue action error:', error);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Plans Status (from Database)</h2>
      {plans.length === 0 && <p><em>no active plans</em></p>}
      <div style={{ marginBottom: 20 }}>
        {plans.map((plan: any) => (
          <div key={plan.id} style={{ 
            borderBottom: '1px solid #ccc', 
            marginBottom: 8, 
            padding: 8,
            backgroundColor: plan.status === 'active' ? '#e8f5e9' : '#fff3e0'
          }}>
            <strong>Plan #{plan.jobNo}</strong> - <span style={{ 
              color: plan.status === 'pending' ? '#ff9800' : plan.status === 'queued' ? '#2196f3' : '#4caf50',
              fontWeight: 'bold'
            }}>{plan.status}</span><br />
            <small>{plan.id}</small><br />
            {plan.title && <div><strong>Title:</strong> {plan.title}</div>}
            <div>{plan.description}</div>
            <div><small>Tasks: {plan.completedCount}/{plan.taskCount}</small></div>
          </div>
        ))}
      </div>

      <h2>Task Queue (Redis)</h2>
      {taskJobs.length === 0 && <p><em>no tasks in queue</em></p>}
      {taskJobs.map((job: any) => (
        <div key={job.id} style={{ borderBottom: '1px solid #ccc', marginBottom: 8 }}>
          <strong>{job.worker}</strong> (queue: {job.queue})<br />
          <small>{job.id}</small><br />
          payload: {JSON.stringify(job.payload)}<br />
          <button onClick={() => doAction(job.id, 'cancel', job.queue)} style={{ marginRight: 4 }}>cancel</button>
          <button onClick={() => doAction(job.id, 'requeue', job.queue)} style={{ marginRight: 4 }}>requeue</button>
          <a href={`/dashboard/job-logs?id=${job.id}`}>view logs</a>
        </div>
      ))}
      
      <h2>Planner Queue (Redis)</h2>
      {agentJobs.length === 0 && <p><em>no plans in planner queue</em></p>}
      {agentJobs.map((job: any) => (
        <div key={job.id} style={{ borderBottom: '1px solid #ccc', marginBottom: 8 }}>
          <strong>{job.worker}</strong> (queue: {job.queue})<br />
          <small>{job.id}</small><br />
          payload: {JSON.stringify(job.payload)}<br />
          <button onClick={() => doAction(job.id, 'cancel', job.queue)} style={{ marginRight: 4 }}>cancel</button>
          <button onClick={() => doAction(job.id, 'requeue', job.queue)} style={{ marginRight: 4 }}>requeue</button>
          <a href={`/dashboard/job-logs?id=${job.id}`}>view logs</a>
        </div>
      ))}
    </div>
  );
}
